import { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const meses = [
  { num: 1, label: 'Jan' }, { num: 2, label: 'Fev' }, { num: 3, label: 'Mar' },
  { num: 4, label: 'Abr' }, { num: 5, label: 'Mai' }, { num: 6, label: 'Jun' },
  { num: 7, label: 'Jul' }, { num: 8, label: 'Ago' }, { num: 9, label: 'Set' },
  { num: 10, label: 'Out' }, { num: 11, label: 'Nov' }, { num: 12, label: 'Dez' },
];

function Despesas() {
  const mesAtual = new Date().getMonth() + 1;
  const anoAtual = new Date().getFullYear();
  const [mesSelecionado, setMesSelecionado] = useState(mesAtual);
  const [anoSelecionado, setAnoSelecionado] = useState(anoAtual);
  const [despesas, setDespesas] = useState([]);
  const [abaAtiva, setAbaAtiva] = useState('fixa');
  const [carregando, setCarregando] = useState(true);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [novaDespesa, setNovaDespesa] = useState({ nome: '', valor: '', totalParcelas: '' });
  const [editando, setEditando] = useState(null);

  const formatarMoeda = (valor) => Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  useEffect(() => {
    buscarDespesas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mesSelecionado, anoSelecionado]);

  const buscarDespesas = async () => {
    setCarregando(true);
    const { data, error } = await supabase.from('despesas').select('*')
      .eq('mes', String(mesSelecionado)).eq('ano', String(anoSelecionado));
    if (!error) setDespesas(data || []);
    setCarregando(false);
  };

  const salvarEdicao = async () => {
    if (!editando) return;
    const valor = editando.campo === 'valor' ? parseFloat(editando.valor)
      : editando.campo === 'parcela_atual' || editando.campo === 'total_parcelas' ? parseInt(editando.valor)
      : editando.valor;
    await supabase.from('despesas').update({ [editando.campo]: valor }).eq('id', editando.id);
    setEditando(null);
    buscarDespesas();
  };

  const adicionarDespesa = async () => {
    if (!novaDespesa.nome || !novaDespesa.valor) return;
    await supabase.from('despesas').insert({
      nome: novaDespesa.nome,
      valor: parseFloat(novaDespesa.valor),
      categoria: abaAtiva,
      mes: mesSelecionado,
      ano: anoSelecionado,
      ...(abaAtiva === 'parcela' && {
        parcela_atual: 1,
        total_parcelas: parseInt(novaDespesa.totalParcelas) || 1
      })
    });
    buscarDespesas();
    setNovaDespesa({ nome: '', valor: '', totalParcelas: '' });
    setMostrarForm(false);
  };

  const removerDespesa = async (id) => {
    await supabase.from('despesas').delete().eq('id', id);
    buscarDespesas();
  };

  const CelulaEditavel = ({ despesa, campo, display, tipo = 'text' }) => {
    const estaEditando = editando?.id === despesa.id && editando?.campo === campo;
    return estaEditando ? (
      <td className="p-4">
        <div className="flex items-center gap-2">
          <input autoFocus type={tipo} value={editando.valor}
            onChange={(e) => setEditando({ ...editando, valor: e.target.value })}
            onKeyDown={(e) => { if (e.key === 'Enter') salvarEdicao(); if (e.key === 'Escape') setEditando(null); }}
            className="bg-gray-700 text-white rounded px-2 py-1 text-sm border border-blue-500 outline-none w-32" />
          <button onClick={salvarEdicao} className="text-green-400 hover:text-green-300 text-xs">✓</button>
          <button onClick={() => setEditando(null)} className="text-gray-400 hover:text-gray-300 text-xs">✕</button>
        </div>
      </td>
    ) : (
      <td className="p-4">
        <div className="flex items-center gap-2 group">
          <span className="text-white">{display}</span>
          <button onClick={() => setEditando({ id: despesa.id, campo, valor: String(despesa[campo]) })}
            className="opacity-0 group-hover:opacity-100 text-gray-500 hover:text-blue-400 transition-all text-xs">
            ✏️
          </button>
        </div>
      </td>
    );
  };

  const listaAtiva = despesas.filter(d => d.categoria === abaAtiva);
  const totalFixas = despesas.filter(d => d.categoria === 'fixa').reduce((acc, d) => acc + Number(d.valor), 0);
  const totalCartao = despesas.filter(d => d.categoria === 'cartao').reduce((acc, d) => acc + Number(d.valor), 0);
  const totalParcelas = despesas.filter(d => d.categoria === 'parcela').reduce((acc, d) => acc + Number(d.valor), 0);
  const totalGeral = totalFixas + totalCartao + totalParcelas;

  if (carregando) return <div className="flex items-center justify-center h-64"><p className="text-gray-400">Carregando...</p></div>;

  return (
    <div>
      <div className="mb-8 flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-white">Despesas</h2>
          <p className="text-gray-400 mt-1">Controle de gastos — {meses.find(m => m.num === mesSelecionado)?.label} {anoSelecionado}</p>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex gap-2">
            {[2025, 2026, 2027].map((ano) => (
              <button key={ano} onClick={() => setAnoSelecionado(ano)}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${anoSelecionado === ano ? 'bg-blue-600 text-white' : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'}`}>
                {ano}
              </button>
            ))}
          </div>
          <div className="flex gap-2 flex-wrap justify-end">
            {meses.map((mes) => (
              <button key={mes.num} onClick={() => setMesSelecionado(mes.num)}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${mesSelecionado === mes.num ? 'bg-blue-600 text-white' : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'}`}>
                {mes.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4 mb-8">
        {[
          { label: 'Total Geral', valor: totalGeral, cor: 'text-red-400' },
          { label: 'Fixas', valor: totalFixas, cor: 'text-white' },
          { label: 'Cartão (dia 15)', valor: totalCartao, cor: 'text-yellow-400' },
          { label: 'Parcelas (dia 15)', valor: totalParcelas, cor: 'text-orange-400' },
        ].map(({ label, valor, cor }) => (
          <div key={label} className="bg-gray-900 rounded-xl p-6 border border-gray-800">
            <p className="text-gray-400 text-sm">{label}</p>
            <p className={`text-2xl font-bold mt-2 ${cor}`}>{formatarMoeda(valor)}</p>
          </div>
        ))}
      </div>

      <div className="bg-gray-900 rounded-xl border border-gray-800">
        <div className="flex border-b border-gray-800 justify-between items-center pr-6">
          <div className="flex">
            {[{ id: 'fixa', label: 'Fixas' }, { id: 'cartao', label: 'Cartão' }, { id: 'parcela', label: 'Parcelas' }].map((aba) => (
              <button key={aba.id} onClick={() => { setAbaAtiva(aba.id); setMostrarForm(false); }}
                className={`px-6 py-4 text-sm font-medium transition-colors ${abaAtiva === aba.id ? 'text-white border-b-2 border-blue-500' : 'text-gray-400 hover:text-white'}`}>
                {aba.label}
              </button>
            ))}
          </div>
          <button onClick={() => setMostrarForm(!mostrarForm)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors">
            + Nova Despesa
          </button>
        </div>

        {mostrarForm && (
          <div className="p-6 border-b border-gray-800 bg-gray-800/50 flex gap-4 items-end">
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-400">Descrição</label>
              <input type="text" placeholder="Nome da despesa" value={novaDespesa.nome}
                onChange={(e) => setNovaDespesa({ ...novaDespesa, nome: e.target.value })}
                className="bg-gray-700 text-white rounded-lg px-3 py-2 text-sm outline-none border border-gray-600 focus:border-blue-500" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-400">Valor (R$)</label>
              <input type="number" placeholder="0,00" value={novaDespesa.valor}
                onChange={(e) => setNovaDespesa({ ...novaDespesa, valor: e.target.value })}
                className="bg-gray-700 text-white rounded-lg px-3 py-2 text-sm outline-none border border-gray-600 focus:border-blue-500 w-32" />
            </div>
            {abaAtiva === 'parcela' && (
              <div className="flex flex-col gap-1">
                <label className="text-xs text-gray-400">Total de Parcelas</label>
                <input type="number" placeholder="12" value={novaDespesa.totalParcelas}
                  onChange={(e) => setNovaDespesa({ ...novaDespesa, totalParcelas: e.target.value })}
                  className="bg-gray-700 text-white rounded-lg px-3 py-2 text-sm outline-none border border-gray-600 focus:border-blue-500 w-32" />
              </div>
            )}
            <button onClick={adicionarDespesa} className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700">Salvar</button>
            <button onClick={() => setMostrarForm(false)} className="px-4 py-2 bg-gray-700 text-gray-300 rounded-lg text-sm font-medium hover:bg-gray-600">Cancelar</button>
          </div>
        )}

        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-800">
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Descrição</th>
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Valor</th>
              {abaAtiva === 'parcela' && <th className="text-left p-4 text-gray-400 text-sm font-medium">Parcelas</th>}
              {abaAtiva === 'cartao' && <th className="text-left p-4 text-gray-400 text-sm font-medium">Vencimento</th>}
              <th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {listaAtiva.map((despesa) => (
              <tr key={despesa.id} className="border-b border-gray-800 hover:bg-gray-800/50 transition-colors">
                <CelulaEditavel despesa={despesa} campo="nome" display={despesa.nome} tipo="text" />
                <CelulaEditavel despesa={despesa} campo="valor" display={formatarMoeda(despesa.valor)} tipo="number" />
                {abaAtiva === 'parcela' && (
                  <td className="p-4">
                    <div className="flex items-center gap-1">
                      <CelulaEditavel despesa={despesa} campo="parcela_atual" display={despesa.parcela_atual} tipo="number" />
                      <span className="text-gray-500">/</span>
                      <CelulaEditavel despesa={despesa} campo="total_parcelas" display={despesa.total_parcelas} tipo="number" />
                    </div>
                  </td>
                )}
                {abaAtiva === 'cartao' && <td className="p-4 text-gray-400">Dia 15</td>}
                <td className="p-4">
                  <button onClick={() => removerDespesa(despesa.id)}
                    className="text-gray-600 hover:text-red-400 transition-colors text-sm">✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="p-4 border-t border-gray-800 flex justify-end">
          <span className="text-white font-semibold">
            Total: {formatarMoeda(abaAtiva === 'fixa' ? totalFixas : abaAtiva === 'cartao' ? totalCartao : totalParcelas)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Despesas;